import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import { PurchasingSupplier } from '@Purchasing/Domain/Model/PurchaseProcess'
import {
    CreatePurchasingSupplierPayload,
    UpdatePurchasingSupplierPayload,
} from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'

export interface GetPurchasingSuppliers {
    execute(params?: {
        active?: boolean
        search?: string
    }): Promise<PurchasingSupplier[]>
}

export class GetPurchasingSuppliersUseCase implements GetPurchasingSuppliers {
    constructor(private repository: PurchasingRepository) {}
    execute(params?: {
        active?: boolean
        search?: string
    }): Promise<PurchasingSupplier[]> {
        return this.repository.getSuppliers(params)
    }
}

export interface SearchPurchasingSuppliers {
    execute(query: string): Promise<PurchasingSupplier[]>
}

export class SearchPurchasingSuppliersUseCase
    implements SearchPurchasingSuppliers
{
    constructor(private repository: PurchasingRepository) {}
    execute(query: string): Promise<PurchasingSupplier[]> {
        return this.repository.searchSuppliers(query)
    }
}

export interface CreatePurchasingSupplier {
    execute(
        payload: CreatePurchasingSupplierPayload
    ): Promise<PurchasingSupplier>
}

export class CreatePurchasingSupplierUseCase
    implements CreatePurchasingSupplier
{
    constructor(private repository: PurchasingRepository) {}
    execute(
        payload: CreatePurchasingSupplierPayload
    ): Promise<PurchasingSupplier> {
        return this.repository.createSupplier(payload)
    }
}

export interface UpdatePurchasingSupplier {
    execute(
        id: string,
        payload: UpdatePurchasingSupplierPayload
    ): Promise<PurchasingSupplier>
}

export class UpdatePurchasingSupplierUseCase
    implements UpdatePurchasingSupplier
{
    constructor(private repository: PurchasingRepository) {}
    execute(
        id: string,
        payload: UpdatePurchasingSupplierPayload
    ): Promise<PurchasingSupplier> {
        return this.repository.updateSupplier(id, payload)
    }
}
